module.exports = __webpack_public_path__ + "static/media/image2.363b6cfc.png";